import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { theme } from '../../themes/theme';
const StyledActiveCell = styled.span `
  color: ${(props) => !props.isActive ? theme.palette.text.secondary : 'inherit'};
`;
const ActiveCell = ({ children, isActive }) => (_jsx(StyledActiveCell, Object.assign({ isActive: isActive }, { children: children })));
export default ActiveCell;
